<template>
  <v-menu offset-y open-on-hover :top="top" :bottom="bottom" :open-delay="1000">
    <template v-slot:activator="{on, attrs}">
      <div :class="classContent" v-bind="attrs" v-on="on">
        <slot></slot>
      </div>
    </template>

    <div class="bg-white pt-2px" :style="{maxWidth: `${maxWidth}px`}">
      <slot name="titulo">
        <span v-text="titulo" class="font-13 font-weight-medium px-2" />
      </slot>

      <v-divider />

      <p class="ma-0 py-1 font-12 px-2">
        <slot name="legenda">
          {{legenda}}
        </slot>
      </p>
    </div>
  </v-menu>
</template>

<script>
export default {
  name: "Legenda",
  props: {
    titulo: String,
    legenda: String,
    classContent: {
      type: String,
      default: 'd-flex align-center cursor-help'
    },
    maxWidth: {
      type: Number,
      default: 500
    },
    top: Boolean,
    bottom: Boolean,
  }
}
</script>

<style scoped>

</style>
